import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";
import { StartActionActivity } from "../../../../../api/omnimap/omnimapApi";

class AddWorkPlanModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      naam: "",
      omschrijving: "",
      naamRequiredAlert: false,
      codeRequiredAlert: false,
      codeAlertText: "",
      code: GC.CodeAutoFill("WO"),
      status: "",
      toezichthouder: "",
      toezichthouderText: "",
      active: true,
    };
    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  resetForm = async () => {
    await this.setState(this.baseState);
    await this.setState({ code: GC.CodeAutoFill("WO") });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "naam") {
      this.setState({ naamRequiredAlert: false });
    }

    if (name === "toezichthouder") {
      var index = event.nativeEvent.target.selectedIndex;
      this.setState({
        toezichthouderText: event.nativeEvent.target[index].text,
      });
    }
  }

  async hadleSubmit() {
    $("#cover-spin").show(0);

    this.state.naam == ""
      ? await this.setState({ naamRequiredAlert: true })
      : await this.setState({ naamRequiredAlert: false });
    this.state.code == ""
      ? await this.setState({
          codeRequiredAlert: true,
          codeAlertText: "required",
        })
      : await this.setState({ codeRequiredAlert: false, codeAlertText: "" });

    let model = {
      relationships: { definition: { code: "WERKORDER" } },
      content: {
        algemeen: {
          startus: this.state.status,
          actief: this.state.active,
          toezichthouder: {
            identification: this.state.toezichthouder,
            display: [
              { path: "$.alias", value: this.state.toezichthouderText },
            ],
          },
          naam: this.state.naam,
          omschrijving: this.state.omschrijving,
          code: this.state.code,
        },
      },
    };

    if (!this.state.naamRequiredAlert) {
      let result = await omnimap.SaveOrEditAction(
        model,
        "POST",
        "",
        window.$catalog_management_units_token
      );
      if (result.result.status === "OK") {
        CallBackFunctions.WerkplanSavedCallBack(
          window.$catalog_management_units_token,
          result.data.identification
        );
      }
    } else {
      $("#cover-spin").hide(0);
    }
  }

  async componentDidMount() {
    var that = this;
    $(document).on("click", "#werkorder_toevoegen", async function () {
      $("#werkorder_toevoegen_modal").modal("show");

      // let directievoerders = await omnimap.GetUserByRoleAction(
      //   1,
      //   6,
      //   "Toezichthouder",
      //   window.$catalog_management_units_token
      // );
      // await CallBackFunctions.DirectievoerderCallbackForCreate(
      //   directievoerders.data
      // );

      // CommonFunctions.GetColumnProperties("create");
      that.resetForm();
    });
  }

  render() {
    return (
      <div>
        <div
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          id="werkorder_toevoegen_modal"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Nieuw Werkorder</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {/* //**werkorder Naam */}
                <label
                  className={
                    this.state.naamRequiredAlert
                      ? "modale-submit-alert-block"
                      : ""
                  }
                >
                  Naam *
                </label>{" "}
                <label
                  className={
                    this.state.naamRequiredAlert
                      ? "modale-submit-alert-block"
                      : "modale-submit-alert-none"
                  }
                >
                  {"\u00A0"} required
                </label>
                <input
                  id="werkorder-naam"
                  type="input"
                  className="form-control"
                  placeholder="Naam werkorder"
                  autocomplete="off"
                  name="naam"
                  value={this.state.naam}
                  onChange={this.handleInputChange}
                />
                {/* //**Omschrijving */}
                <label>Omschrijving</label>
                <input
                  id="werkorder-omschrijving"
                  type="input"
                  className="form-control"
                  placeholder="Code"
                  autocomplete="off"
                  name="omschrijving"
                  value={this.state.omschrijving}
                  onChange={this.handleInputChange}
                />
                {/* //**werkorder Code */}
                <label
                  className={
                    this.state.codeRequiredAlert
                      ? "modale-submit-alert-block"
                      : ""
                  }
                >
                  Code *
                </label>
                <label
                  className={
                    this.state.codeRequiredAlert
                      ? "modale-submit-alert-block"
                      : "modale-submit-alert-none"
                  }
                >
                  {"\u00A0"} {this.state.codeAlertText}
                </label>
                <input
                  id="werkorder-code"
                  type="input"
                  className="form-control"
                  placeholder="Code"
                  autocomplete="off"
                  name="code"
                  value={this.state.code}
                  onChange={this.handleInputChange}
                />
                {/* //**werkorder Status */}
                {/* <label>Status *</label>
                <select
                  class="form-control"
                  id="werkorder-status"
                  name="status"
                  value={this.state.status}
                  onChange={this.handleInputChange}
                ></select> */}
                {/* //**werkorder Toezichthouder */}
                {/* <label>Status *</label>
                <select
                  class="form-control"
                  id="werkorder-toezichthouder"
                  name="toezichthouder"
                  value={this.state.toezichthouder}
                  onChange={this.handleInputChange}
                ></select> */}
                {/* //**werkorder Actief */}
                <label>Actief</label>
                <label className="switch">
                  <input
                    id="werkorder-active"
                    type="checkbox"
                    defaultChecked
                    name="active"
                    value={this.state.active}
                    onChange={this.handleInputChange}
                  />
                  <span className="slider-checkbox round" />
                </label>
                <br />
                <br />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  id="save-werkorder"
                  className="btn-modal"
                  onClick={this.hadleSubmit.bind(this)}
                >
                  Verwerken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddWorkPlanModal;
